import styled from 'styled-components';

import { spinner } from '../../styles/mixins';

/**
 * Botão do redesign: retângulo arredondado, rótulo em caixa alta e cor sólida
 * (a marca Due não usa gradiente).
 *
 * `primary` é a ação principal (azul da marca); sem ele o botão fica secundário
 * (contorno). `color` continua sobrescrevendo a cor para os casos pontuais que
 * já existiam nas telas.
 */
const StyledButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
  padding: 0 2.4rem;
  min-width: ${props => `${props.minWidth || 0}px`};
  border-radius: var(--r-btn);
  white-space: nowrap;

  background-color: ${({ color, primary }) => {
    if (!primary) return 'transparent';
    return color || 'var(--accent)';
  }};

  border: ${({ color, primary }) => {
    if (primary) return '1px solid transparent';
    return `1px solid ${color || 'var(--border-strong)'}`;
  }};

  /* Os ícones do botão usam currentColor. */
  color: ${({ color, primary }) => {
    if (primary) return '#fff';
    return color || 'var(--ink)';
  }};

  transition: background-color var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard),
    transform var(--dur-fast) var(--ease-standard);

  :hover:not(:disabled) {
    background-color: ${({ color, primary }) => {
      if (primary) return color || 'var(--accent-deep)';
      return color ? 'transparent' : 'var(--surface-2)';
    }};
    border-color: ${({ color, primary }) =>
      primary ? 'transparent' : color || 'var(--ink-soft)'};
    opacity: ${({ color, primary }) => (color && primary ? 0.85 : 1)};
  }

  :active:not(:disabled) {
    transform: scale(0.97);
  }

  /* Carregando não é o mesmo que desabilitado: o botão continua com a cor da
     ação para a pessoa não achar que perdeu o clique. */
  &[data-loading='true'] {
    cursor: wait;
    opacity: 0.8;
  }

  :disabled:not([data-loading='true']) {
    background-color: var(--surface-2);
    border-color: var(--border);
    cursor: not-allowed;

    p {
      color: var(--ink-faint);
    }
  }
`;

const ButtonText = styled.p`
  color: ${({ color, primary }) => {
    if (primary) return '#fff';
    return color || 'var(--ink)';
  }};
  font-weight: ${({ bold }) => (bold ? 700 : 600)};
  font-size: 1.35rem;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  text-align: center;
`;

const Spinner = styled.span`
  flex: none;
  width: 1.5rem;
  height: 1.5rem;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  ${spinner}
`;

export { StyledButton, ButtonText, Spinner };
